export class MaxPainel {
  id: number;
  ateQtd: number;
  medidaPerfil: number;
}
